module.exports = __webpack_public_path__ + "img/400.7be774b0.svg";